module.exports = __webpack_public_path__ + "img/Recubre_Estuco Blanco.a0122059.png";